// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__rmyUf","facebook":"SocialLinks_facebook__wQn7U","tiktok":"SocialLinks_tiktok__6gtZz","instagram":"SocialLinks_instagram__Vpn+B"};